/* eslint-disable react/prop-types */
import React, { PureComponent } from 'react';
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import { Helmet } from 'react-helmet';

class ErrorPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }

  componentDidMount() {
    //
  }

  render() {
    const { message } = this.props;
    return (
      <>
        <Helmet>
          <title>Learning bites opt out</title>
        </Helmet>
        <Container>
          <Row>
            <Col xs={12} md="auto" className="mx-auto">
              <img src="https://static-dev.hellomonday.co/auth/images/hm_ja_logos.png" className="img-fluid" alt="JA and HM logo" />
            </Col>
          </Row>
          <Row className="text-center">
            <Col xs={12} className="my-3">
              <h4>{message}</h4>
            </Col>
            <Col xs={12} className="my-3">
              <svg width="335" height="199" viewBox="0 0 335 199" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M287.059 180.408C315.944 178.264 337.153 159.881 334.132 139.444C331.104 119.063 305.056 104.106 276.09 106.244C263.863 107.157 252.828 100.821 251.538 92.1938C250.248 83.5663 259.232 75.7784 271.46 74.8653L274.089 74.6497C286.807 73.7139 296.08 65.6027 294.758 56.6292C293.436 47.6558 281.943 41.1157 269.225 42.0515L261.105 42.6244C256.185 42.9647 251.677 40.4122 251.196 36.9408C250.715 33.4694 254.335 30.2873 259.255 29.947L265.244 29.5102C268.693 29.238 271.194 27.0656 270.802 24.6889C270.417 22.2555 267.339 20.4914 263.97 20.7694L223.926 23.73C218.588 24.1554 213.71 21.3476 213.189 17.587C212.588 13.8206 216.569 10.3776 221.899 10.0089L233.878 9.13548C237.327 8.86323 239.828 6.69079 239.435 4.31413C239.051 1.88075 235.972 0.116674 232.604 0.394594L57.1764 13.2809C52.7467 13.5985 49.4171 16.4573 49.9461 19.5883C50.3947 22.7137 54.4453 25.062 58.883 24.6877L71.1913 23.7802C78.1695 23.2414 84.4703 26.8943 85.2316 31.8178C85.9928 36.7413 80.8053 41.245 73.8352 41.7271L26.3224 45.2493C21.8927 45.5669 18.5631 48.4257 19.0921 51.5567C19.5407 54.6821 23.5912 57.0304 28.029 56.6561L35.8272 56.0606C42.307 55.6011 48.0854 58.9308 48.8227 63.4515C49.4716 68.0233 44.7506 72.1016 38.3432 72.6234L27.5865 73.4685C11.0092 74.705 -1.12706 85.2496 0.539206 96.94C2.28586 108.636 17.2262 117.196 33.8035 115.959L37.2524 115.687C53.1704 114.518 67.5883 122.755 69.2388 133.986C70.8892 145.217 59.2113 155.392 43.2933 156.561L35.8247 157.122C19.746 158.279 7.97156 168.563 9.60584 179.907C11.2401 191.252 25.8108 199.556 41.8896 198.399C125.089 192.296 203.859 186.511 287.059 180.408ZM38.1173 26.2588C33.6072 26.5707 29.629 24.2848 29.1803 21.1594C28.7398 17.9773 31.981 15.1696 36.4107 14.8519C40.9207 14.54 44.8989 16.8259 45.3476 19.9513C45.7962 23.0767 42.547 25.9412 38.1173 26.2588ZM282.714 28.2795C279.265 28.5517 276.187 26.7876 275.882 24.3599C275.498 21.9266 277.999 19.7541 281.44 19.5386C284.889 19.2663 287.967 21.0304 288.271 23.4581C288.656 25.8915 286.154 28.0639 282.714 28.2795Z"
                  fill="#EBF4F4"
                />
                <g opacity="0.4" clipPath="url(#clip0_1587_0)">
                  <path
                    d="M200.817 89.8659H195.812V76.305C195.812 57.9692 180.798 43.0713 162.319 43.0713C143.84 43.0713 128.825 57.9692 128.825 76.305V89.8659H123.82C119.971 89.8659 116.698 93.1128 116.698 96.9328V101.135V150.03V154.232C116.698 158.052 119.971 161.299 123.82 161.299H162.319H200.817C204.667 161.299 207.939 158.052 207.939 154.232V150.03V101.135V96.9328C207.939 93.1128 204.667 89.8659 200.817 89.8659ZM169.826 140.289H154.619L157.314 127.493C154.812 125.965 153.079 123.1 153.079 119.853C153.079 114.887 157.122 110.876 162.126 110.876C167.131 110.876 171.173 114.887 171.173 119.853C171.173 123.1 169.441 125.774 166.939 127.493L169.826 140.289ZM162.319 89.8659H140.76V76.305C140.76 64.4631 150.384 54.9132 162.319 54.9132C174.253 54.9132 183.878 64.4631 183.878 76.305V89.8659H162.319Z"
                    fill="#8BC2C2"
                  />
                </g>
                <g clipPath="url(#clip1_1587_0)">
                  <path
                    d="M203.388 87.2955H198.383V73.7347C198.383 55.3988 183.369 40.501 164.89 40.501C146.41 40.501 131.396 55.3988 131.396 73.7347V87.2955H126.391C122.541 87.2955 119.269 90.5425 119.269 94.3625V98.5644V147.46V151.662C119.269 155.482 122.541 158.729 126.391 158.729H164.89H203.388C207.238 158.729 210.51 155.482 210.51 151.662V147.46V98.5644V94.3625C210.51 90.5425 207.238 87.2955 203.388 87.2955ZM172.397 137.719H157.19L159.885 124.922C157.382 123.394 155.65 120.529 155.65 117.282C155.65 112.316 159.692 108.305 164.697 108.305C169.702 108.305 173.744 112.316 173.744 117.282C173.744 120.529 172.012 123.203 169.509 124.922L172.397 137.719ZM164.89 87.2955H143.331V73.7347C143.331 61.8928 152.955 52.3429 164.89 52.3429C176.824 52.3429 186.449 61.8928 186.449 73.7347V87.2955H164.89Z"
                    fill="#29CACB"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1587_0">
                    <rect width="91.2411" height="118.228" fill="white" transform="translate(116.698 43.0713)" />
                  </clipPath>
                  <clipPath id="clip1_1587_0">
                    <rect width="91.2411" height="118.228" fill="white" transform="translate(119.269 40.501)" />
                  </clipPath>
                </defs>
              </svg>
            </Col>
            <Col xs={12}>
              <h4 className="mt-3 text-secondary font-weight-normal">
                There was an error loading the page, please try clicking the page again.
                If the error persists please call 1300 833 953 for support
              </h4>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default ErrorPage;
